import instance from './axiosInstance';

const routerPrefix = 'notification-channel/ai-alerts-email-subscription';

export const fetchSubscriptionList = async () => {
  return instance.get(`${routerPrefix}/list`);
};

export const createOrUpdateSubscription = async (payload) => {
  return instance.post(`${routerPrefix}/subscription`, {
    query: payload,
  });
};

export const fetchSubscriptionByEmailId = async (emailId: string) => {
  return instance.post(`${routerPrefix}/fetch_subscription/`, {
    query: {
      email: emailId,
    },
  });
};

export const unsubscribeSubscription = async (payload) => {
  return instance.delete(`${routerPrefix}/unsubscribe/`, {
    data: {
      query: payload,
    },
  });
};

export const fetchCustomerAllUsersEmail = async (hidden) => {
  return instance.get(`/customer/user_emails?include_hidden=${hidden}`);
};
